import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=885625a8&scoped=true"
import script from "./input-text.vue?vue&type=script&lang=js"
export * from "./input-text.vue?vue&type=script&lang=js"
import style0 from "./input-text.vue?vue&type=style&index=0&id=885625a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885625a8",
  null
  
)

export default component.exports